import { APP_CONFIG } from "app.config";
import { environment } from "environments/environment";

export class AppStateConstant {
    static userName: string = 'username' + APP_CONFIG.APP_CODE + environment.name;
    static appState: string = APP_CONFIG.APP_CODE + '_APP_STATE' + environment.name;
    static JWT: string = 'JWT_' + APP_CONFIG.APP_CODE + environment.name;
    static Language: string = 'language' + environment.name;
    static AccessToken: string = APP_CONFIG.APP_CODE + '_accessToken_' + environment.name;
    static IdToken: string = APP_CONFIG.APP_CODE + '_idToken_' + environment.name;
    static authProvider: string = APP_CONFIG.APP_CODE + '_authProvider_' + environment.name;
    static RefreshToken: string = APP_CONFIG.APP_CODE + '_refreshToken_' + environment.name;
    static ServerToken: string = APP_CONFIG.APP_CODE + '_serverToken_' + environment.name;
    static X_AWS_Authorization: string = APP_CONFIG.APP_CODE + 'X-AWS-Authorization' + environment.name;
    static firstLogin: string = APP_CONFIG.APP_CODE + '_firstLogin' + environment.name;

    static lowcoderFormKey: string = APP_CONFIG.APP_CODE + '_lowcoderFormKey' + environment.name;
    static HasuraToken: string = APP_CONFIG.APP_CODE + '_HasuraToken_' + environment.name;
    static GraphqlAction: string = APP_CONFIG.APP_CODE + '_GraphqlAction' + environment.name;

    static SIGNIN_AZURE_AD: string = 'SIGNIN_AZURE_AD';
    static SIGNIN_AWS_COGNITO: string = 'SIGNIN_AWS_COGNITO';
    static SIGNIN_ZITADEL: string = 'SIGNIN_ZITADEL';
    static IDP_CALLBACK_DATA: string = APP_CONFIG.APP_CODE + '_IDP_CALLBACK_DATA' + environment.name;
}